import { Component } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
//import { NewsMediaService } from './news-media.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { CbicContentTypeMstService } from 'app/entities/cbic-content-type-mst/service/cbic-content-type-mst.service';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { DataUtils } from 'app/core/util/data-util.service';
import { UtilsService } from 'app/core/util/view-file.component';
import { CbicMenuMstService } from 'app/entities/cbic-menu-mst/service/cbic-menu-mst.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MediaComponent } from 'app/layouts/media/media.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';

@Component({
  selector: 'cbic-news-media',
  templateUrl: './news-media.component.html',
  styleUrls: ['./news-media.component.scss']
})
export class NewsMediaComponent {
  [x: string]: any;
  contentData: any;
  newsMediaData: any
  newsMediaDataList: any;
  newsMediaDataNotfound: any;
  page = 1;
  Pageing = 0;
  pageSize: any;
  count = 0;
  tableSize = 10;
  tabindex = 0;
  tableSizes = [10, 15, 20, 25, 50, 100];
  pdfCategory = ["Media", "Current Press Release", "Old Press Release"];
  contentType: any;

  constructor(private contentMstService: CbicContentMstService,
    private sessionStorageService: SessionStorageService,
    private utils: UtilsService, public menuService: CbicMenuMstService,
    private modalService: NgbModal, private activetedRoute: ActivatedRoute,  
    private changeLnService: ChangeLanguageService, private cbicContentMstService: CbicContentMstService,
    private http: HttpClient,) { }

  ngOnInit(): void {
    this.activetedRoute.data.subscribe(({ contentTypeCode }) => {
      this.contentType = contentTypeCode;
      this.getNewsAndMediaContent(contentTypeCode);
      //  -- for displaying popup
      // this.utils.viewOpenning("CONTENTREPO/CitizenCorner/photo/BigLeap_27122024.jpg");  
    });
  }
  getSelectedIndex() {
    return this.tabindex;
  }
  getNewsAndMediaContent(contentTypeCode: string): void {
    this.contentMstService.getContentData(contentTypeCode).subscribe((res: HttpResponse<any>) => {
      if (res) {
        this.contentData = res.body;
      }
      if (this.contentType === "citizens-corner") {
        this.getNewsAndMedia(this.contentData[1].id);
        this.tabindex = 3;
      }
      else {
        this.getNewsAndMedia(this.contentData[0].id)
      }
    });
  }

  getNewsAndMedia(contentId: any): void {
    this.contentMstService.getNewsAndMediaData(contentId, 0, 1000).subscribe((res: HttpResponse<any>) => {
      if (res) {
        this.newsMediaData = res;
      }
    });
  }

  getGridData(contentId: any): void {
    console.log(contentId);
    this.cbicContentMstService.getNewsAndMediaData(contentId, 0, 10).
      subscribe((res) => {
        if (res) {
          console.log(res);
          const data: ICbicContentMst = res;
          this.newsMediaData = data;
        }

      });
  }

  isDataAvailable() {
    let dataAvailable = true;
    dataAvailable &&= this.newsMediaData.childContentList != null && this.newsMediaData.childContentList.length !== 0;
    if (dataAvailable === false) {
      this.newsMediaDataNotfound = 'No data available.';
    }
    return dataAvailable;
  };

  ViewPdf(filePath: any) {
    this.utils.viewOpenning(filePath);
  }

  onTableDataChange(page: any) {
    this.Pageing = page.pageIndex.toString();
    this.pageSize = page.pageSize.toString();
  }

  ontableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    const request: any = {};
    this.Pageing = event.pageIndex.toString();
    request['size'] = event.pageSize.toString();
  }

  onCategoryChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    const request: any = {};
    this.Pageing = event.pageIndex.toString();
    request['size'] = event.pageSize.toString();
  }

  tabClick(event: MatTabChangeEvent) {
    this.newsMediaData = null;
    this.tabindex = event.index;
    if (this.tabindex !== 3) {
      this.getNewsAndMedia(event.tab.textLabel);
    }
    else if (this.contentType === "citizens-corner") {
      this.getNewsAndMedia(event.tab.textLabel);
    }
  }

  tabHomeClick(contentId: any) {

    this.getNewsAndMedia(contentId);
    console.log(contentId);
    //this.tabindex=this.tabindex;

  }

  viewFile(doc: ICbicDocMst) {
    let filePath = doc.filePathEn;
    if (this.changeLnService.getLanguage() === 'hi' && doc.filePathHi) {
      filePath = doc.filePathHi;
    }
    this.utils.viewOpenning(filePath ?? "");
  }

  openmodelPopup(path: any, doctype: any) {
    const modelRef = this.modalService.open(MediaComponent,
      { modalDialogClass: 'modal-dialog modal-dialog-centered modal-lg', size: 'lg' });
    modelRef.componentInstance.modelRef = modelRef;
    modelRef.componentInstance.path = path;
    modelRef.componentInstance.type = doctype;
  }
}


